import React from 'react';
import sanitizeHtml from 'sanitize-html';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import { Box, Button, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Clear } from '@mui/icons-material';
import { BUSINESS_PACKAGE_CODES, PACKAGE_TYPE } from '@src/constants/package';
import { LANGUAGE } from '@src/constants';
import { CONTACT_US_PAGE } from '@src/configs';

const BusinessPackageItem = ({ isColumn, data }) => {
  const { t, i18n: i18nP } = useTranslation();
  const { language } = i18nP;
  return (
    <>
      <div
        className={classnames(
          isColumn ? 'isColumn business-package' : 'business-package',
          data?.type === PACKAGE_TYPE.API && 'package-api',
        )}
      >
        <div className="left-content">
          <span
            className="business-title"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(
                language === LANGUAGE.VN
                  ? data?.name[language]
                  : data?.name[LANGUAGE.EN],
              ),
            }}
          />
          <span
            className="text-content"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(
                language === LANGUAGE.VN
                  ? data?.description[language]
                  : data?.description[LANGUAGE.EN],
              ),
            }}
          />
          <a href={CONTACT_US_PAGE}>
            <Button className="btn-contact" color="primary" variant="contained">
              {t('contact')}
            </Button>
          </a>

          <Divider
            sx={{
              mb: BUSINESS_PACKAGE_CODES.includes(data?.code) ? '24px' : '20px',
            }}
          />
          <div className={isColumn && 'list-info-pack'}>
            {data?.contents?.map((item) => (
              <Box
                alignItems="center"
                display="flex"
                justifyContent="space-between"
                className="package-content-item"
              >
                <div className="clarify" key={item.vi}>
                  <div className="icon-contents">
                    {item.active ? (
                      <FiberManualRecordRoundedIcon className="dots" />
                    ) : (
                      <Clear fontSize="small" color="light" />
                    )}
                  </div>
                  <div
                    className={item.active ? 'content' : 'content-deactivate'}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHtml(
                        language === LANGUAGE.VN
                          ? item?.[language]
                          : item[LANGUAGE.EN],
                      ),
                    }}
                  />
                </div>
              </Box>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessPackageItem;
